// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs-min": "@media screen and (min-width: 320px)",
	"xsm-min": "@media screen and (min-width: 325px)",
	"sms-min": "@media screen and (min-width: 360px)",
	"sm-min": "@media screen and (min-width: 375px)",
	"ml-min": "@media screen and (min-width: 426px)",
	"smlg-min": "@media screen and (min-width: 456px)",
	"sml-min": "@media screen and (min-width: 480px)",
	"mui-sm-min": "@media screen and (min-width: 601px)",
	"md-sm-min": "@media screen and (min-width: 768px)",
	"md-min-min": "@media screen and (min-width: 833.5px)",
	"md-min": "@media screen and (min-width: 834px)",
	"mlg-min": "@media screen and (min-width: 1024px)",
	"lg-min": "@media screen and (min-width: 1280px)",
	"xl-min": "@media screen and (min-width: 1440px)",
	"xxl-min": "@media screen and (min-width: 1850px)",
	"3xl-min": "@media screen and (min-width: 1920px)",
	"xs-min-media": "(min-width: 320px)",
	"xsm-min-media": "(min-width: 325px)",
	"sms-min-media": "(min-width: 360px)",
	"sm-min-media": "(min-width: 375px)",
	"ml-min-media": "(min-width: 426px)",
	"smlg-min-media": "(min-width: 456px)",
	"sml-min-media": "(min-width: 480px)",
	"mui-sm-min-media": "(min-width: 601px)",
	"md-sm-min-media": "(min-width: 768px)",
	"md-min-min-media": "(min-width: 833.5px)",
	"md-min-media": "(min-width: 834px)",
	"mlg-min-media": "(min-width: 1024px)",
	"lg-min-media": "(min-width: 1280px)",
	"xl-min-media": "(min-width: 1440px)",
	"xxl-min-media": "(min-width: 1850px)",
	"3xl-min-media": "(min-width: 1920px)",
	"xs-max-media": "(max-width: 320px)",
	"xsm-max-media": "(max-width: 325px)",
	"sms-max-media": "(max-width: 360px)",
	"sm-max-media": "(max-width: 375px)",
	"ml-max-media": "(max-width: 426px)",
	"smlg-max-media": "(max-width: 456px)",
	"sml-max-media": "(max-width: 480px)",
	"mui-sm-max-media": "(max-width: 601px)",
	"md-sm-max-media": "(max-width: 768px)",
	"md-min-max-media": "(max-width: 833.5px)",
	"md-max-media": "(max-width: 834px)",
	"mlg-max-media": "(max-width: 1024px)",
	"lg-max-media": "(max-width: 1280px)",
	"xl-max-media": "(max-width: 1440px)",
	"xxl-max-media": "(max-width: 1850px)",
	"3xl-max-media": "(max-width: 1920px)",
	"xs-max": "@media screen and (max-width: 320px)",
	"xsm-max": "@media screen and (max-width: 325px)",
	"sms-max": "@media screen and (max-width: 360px)",
	"sm-max": "@media screen and (max-width: 375px)",
	"ml-max": "@media screen and (max-width: 426px)",
	"smlg-max": "@media screen and (max-width: 456px)",
	"sml-max": "@media screen and (max-width: 480px)",
	"mui-sm-max": "@media screen and (max-width: 601px)",
	"md-sm-max": "@media screen and (max-width: 768px)",
	"md-min-max": "@media screen and (max-width: 833.5px)",
	"md-max": "@media screen and (max-width: 834px)",
	"mlg-max": "@media screen and (max-width: 1024px)",
	"lg-max": "@media screen and (max-width: 1280px)",
	"xl-max": "@media screen and (max-width: 1440px)",
	"xxl-max": "@media screen and (max-width: 1850px)",
	"3xl-max": "@media screen and (max-width: 1920px)",
	"xs-maxwidth": "@media screen and (max-width: 319px)",
	"xsm-maxwidth": "@media screen and (max-width: 324px)",
	"sms-maxwidth": "@media screen and (max-width: 359px)",
	"sm-maxwidth": "@media screen and (max-width: 374px)",
	"ml-maxwidth": "@media screen and (max-width: 425px)",
	"smlg-maxwidth": "@media screen and (max-width: 455px)",
	"sml-maxwidth": "@media screen and (max-width: 479px)",
	"mui-sm-maxwidth": "@media screen and (max-width: 600px)",
	"md-sm-maxwidth": "@media screen and (max-width: 767px)",
	"md-min-maxwidth": "@media screen and (max-width: 832.5px)",
	"md-maxwidth": "@media screen and (max-width: 833px)",
	"mlg-maxwidth": "@media screen and (max-width: 1023px)",
	"lg-maxwidth": "@media screen and (max-width: 1279px)",
	"xl-maxwidth": "@media screen and (max-width: 1439px)",
	"xxl-maxwidth": "@media screen and (max-width: 1849px)",
	"3xl-maxwidth": "@media screen and (max-width: 1919px)",
	"ml-md": "@media screen and (min-width: 426px) and (max-width: 833px)",
	"md-lg": "@media screen and (min-width: 834px) and (max-width: 1279px)",
	"md-mlg": "@media screen and (min-width: 834px) and (max-width: 1023px)",
	"mlg-lg": "@media screen and (min-width: 1024px) and (max-width: 1279px)",
	"lg-xl": "@media screen and (min-width: 1280px) and (max-width: 1439px)",
	"lg-xll": "@media screen and (min-width: 1280px) and (max-width: 1849px)",
	"xl-xxl": "@media screen and (min-width: 1440px) and (max-width: 1849px)",
	"ml-md-media": "(min-width: 426px) and (max-width: 833px)",
	"md-lg-media": "(min-width: 834px) and (max-width: 1279px)",
	"md-mlg-media": "(min-width: 834px) and (max-width: 1023px)",
	"mlg-lg-media": "(min-width: 1024px) and (max-width: 1279px)",
	"lg-xl-media": "(min-width: 1280px) and (max-width: 1439px)",
	"lg-xll-media": "(min-width: 1280px) and (max-width: 1849px)",
	"xl-xxl-media": "(min-width: 1440px) and (max-width: 1849px)",
	"chalkWhiteFont": "#fff",
	"cardBgColor": "#122142",
	"indigoDefaultColor": "#05112a",
	"indigoSecondaryColor": "#212e47",
	"fontFamilyTT": "TT Commons",
	"fontFamilyPOP": "Poppins,TT Commons",
	"fontFamilyHind": "Hind",
	"fontFamilyMix": "Hind,Helvetica,Verdana,sans-serif",
	"fontFamilySF": "SF Pro Display",
	"fontFamilyPlusSans": "Plus Jakarta Sans",
	"fontFamilyOpenSans": "Open Sans,Calibri,Tahoma,sans-serif",
	"fontSize10": "10px",
	"fontSize12": "12px",
	"fontSize14": "14px",
	"fontSize16": "16px",
	"fontSize18": "18px",
	"fontSize20": "20px",
	"fontSize22": "22px",
	"fontSize24": "24px",
	"fontSize28": "28px",
	"fontSize32": "32px",
	"fontSize34": "34px",
	"fontSize40": "40px",
	"fontSize48": "48px",
	"fontWeight400": "400",
	"fontWeight600": "600",
	"fontWeight500": "500",
	"fontWeight300": "300",
	"fontWeight700": "700",
	"MUI7_BREAKPOINT_DOWN_SM": "960",
	"MUI7_BREAKPOINT_DOWN_MD": "1280",
	"MUI7_BREAKPOINT_DOWN_LG": "1920",
	"lineHeight150": "150%",
	"lineHeight125": "1.25",
	"lineHeight143": "1.43",
	"iconActiveBgColor": "#ae90ff",
	"profileFontColor": "#05112a",
	"lightGreyBgColor": "#e8eefa",
	"profileActiveBgColor": "#6d0176",
	"thumbnailBackgroundColor": "#c4c4c4",
	"swatchLightFont": "#d2d7e2",
	"swatchDarkFont": "#161c29",
	"whiteFont": "#fefefe",
	"whiteLightFont": "#f7f9fd",
	"warningFont": "#eea42e",
	"purpleLightBgColor": "#9b81e2",
	"purpleHoverBgColor": "#b79bff",
	"purpleBgColor": "#6a43d4",
	"menuListDividerColor": "#9ba1ad",
	"darkBgcolor": "#989ba3",
	"darkBgBorder": "#393f4a",
	"darkThemeColor": "#020917",
	"cardBorderColor": "#203b75",
	"newBadgeColor": "#65016e",
	"newBadgeGradient": "linear-gradient(87.51deg, #7E0188 0.3%, #400146 101.68%)",
	"swatchWarning900": "#231a0e",
	"swatchDark800": "#272d39",
	"orangeGradient": "linear-gradient(135deg, #E49D2D 0%, #EA0B7E 51.09%, #851B4A 100%)",
	"orangeGradientHover": "linear-gradient(135deg, #C08529 0%, #B41863 51.09%, #851B4A 100%)",
	"pinkColor": "#b41863",
	"greyColor": "#dde3ee",
	"mutedTextColor": "#60646d",
	"lightThemeColor": "#655591",
	"mutedBlack": "#333",
	"swatchPrimary": "#ea0b7e",
	"yellowishOrange": "#e49d2d",
	"gradient02": "#0cc0ad",
	"loaderGradient": "linear-gradient(270deg, rgba(57, 63, 74, 0) 19.64%, #393F4A 60%)",
	"swatchInfo": "#31b9e1",
	"swatchInfoDark": "#131d21",
	"lightGreen": "#19a292",
	"swatchDanger": "#9a4341",
	"quaternary": "#e8e6f3",
	"color_text_primary": "#171717",
	"color_text_secondary": "#6a7070",
	"optionLabelColor": "#1f2430",
	"zambezi": "#5d5d5d",
	"navyColor": "#0d004d",
	"greyScaleColor": "#464646",
	"amethystColor": "#512eab",
	"amethystColorV2": "#3d1788",
	"amethystLightColor": "rgba(81,46,171,.15)",
	"amethystDisabledColor": "rgba(81,46,171,.4)",
	"feedBackColor": "#f6f6fb",
	"blueColor": "#045caf",
	"lineHeight24": "24px",
	"lineHeight20": "20px",
	"lineHeight22": "22px",
	"lineHeight175": "28px",
	"lineHeight32": "32px",
	"lineHeight16": "16px",
	"purpleSelectedTabUnderline": "#c1bfff",
	"tabFocusVisibleColor": "#31bbf5",
	"amethyst": "#512eab",
	"accentGreen": "#006632",
	"accentColor": "#ebf9f0",
	"accentLightRed": "#ffe7e5",
	"accentRed": "#b20900",
	"accentLightOrange": "#fffbeb",
	"accentBrown": "#793c00",
	"accentOrange": "#806700",
	"accentGreenDark": "#00b057",
	"accentYellow": "#ffce00",
	"accentRedDark": "#ff362a",
	"linkDefault": "#0576e1",
	"secondaryButtonHoverColor": "#cdcbde",
	"secondaryButtonFocusColor": "#2392fb",
	"accentHotspotColor": "#ff362a",
	"color_elevation_alpha_04": "rgba(13,0,77,.05)",
	"color_elevation_alpha_08": "rgba(13,0,77,.1)",
	"color_elevation_alpha_12": "rgba(13,0,77,.15)",
	"paperElevation8BoxShadow": "0px 5px 5px -3px rgba(0,0,0,.2),0px 8px 10px 1px rgba(0,0,0,.14),0px 3px 14px 2px rgba(0,0,0,.12)",
	"accentNotAttempted": "#e8e6f3",
	"badgeBgColoe": "#ff5722",
	"tabHoverColor": "#c4cbe2",
	"darkThemeBgColor": "#272247",
	"darkThemeBgColor2": "#100c24",
	"darkThemeTextColorPrimary": "#e8e8e8",
	"darkThemeTextColorTertiary": "#a2a2a2",
	"darkCompletedBgColor": "#474363",
	"darkCompletedTextColor": "#61d198",
	"darkInProgressBgColor": "#474363",
	"darkInProgressTextColor": "#ffe67f",
	"darkNotStartedBgColor": "#474363",
	"darkNotStartedTextColor": "#ff9e99",
	"darkGreatBgColor": "#61d198",
	"darkGettingThereBgColor": "#ffe67f",
	"darkNeedsReviewBgColor": "#ff362a",
	"darkProgressBgColor": "#474362",
	"lightThemeBgColor2": "#efeef7",
	"assignmentReviewBgColor": "#f1f1f8",
	"badgeBgColor": "#efedff",
	"tableBorderBottom": "#dbd9e5",
	"bulkEditCtaButtonDisabledColor": "#8b8b8b",
	"bulkEditCtaButtonDisabledBGColor": "#d1d1d1",
	"timeIconColor": "#2e2e2e",
	"naBGColor": "#ebf5ff",
	"linkHoverColor": "#034787",
	"nameLabelBgColor": "#f2f2f2",
	"disabledTextColor": "#747474",
	"blackColor": "#000",
	"reviewButtonColor": "rgba(13,0,77,.3490196078)",
	"reviewButtonHoverColor": "#252525",
	"flaggedChipColor": "rgba(13,0,77,.1490196078)",
	"optionPrefixColor": "#d0d5dd",
	"prefixCorrectBGColor": "#c4eed2",
	"prefixWrongColor": "#ffcfcc",
	"questionCardbgColor": "#f5f6fa",
	"incompleteProgressColor": "rgba(81,46,171,.1490196078)",
	"accentBlueTextColor": "#ebf5ff",
	"partOfSubscriptionBGColor": "#045caf",
	"upgradeAccessBGColor": "#ffebd6",
	"upgradeAccessColor": "#793c00",
	"lightTextColor2": "#0d004d",
	"disabledInputBoxColor": "#b9b9b9",
	"progressInprogressColor": "#efa0e7"
};
export default ___CSS_LOADER_EXPORT___;
